import { ReactNode } from "react";

import { BoxProps } from "../Box";
import { TypographyProps } from "../Typography";
import SectionWrapper from "./components/Wrapper";
import SectionHeader from "./components/Header";
import SectionContent from "./components/Content";

type SectionProps = {
  children: ReactNode;
  title: ReactNode;
  titleTag?: TypographyProps["tag"];
  titleVariant?: TypographyProps["variant"];
  className?: string;
  headerClassName?: string;
  headerSuffix?: ReactNode;
  titleSuffix?: ReactNode;
  headerPrefix?: ReactNode;
  contentGap?: BoxProps["gap"];
  fullbleed?: boolean;
  headerAlign?: BoxProps["align"];
} & Pick<BoxProps, "fullHeight" | "fullWidth" | "margin" | "padding">;

const Section = ({
  headerAlign = "center",
  children,
  title,
  className,
  headerClassName,
  headerSuffix,
  titleSuffix,
  headerPrefix,
  titleTag,
  titleVariant,
  contentGap,
  fullbleed,
  ...restBoxProps
}: SectionProps) => (
  <SectionWrapper className={className} {...restBoxProps}>
    {title && (
      <SectionHeader
        align={headerAlign}
        titleTag={titleTag}
        titleVariant={titleVariant}
        titleSuffix={titleSuffix}
        suffix={headerSuffix}
        className={headerClassName}
        prefix={headerPrefix}
      >
        {title}
      </SectionHeader>
    )}
    <SectionContent fullbleed={fullbleed} gap={contentGap}>
      {children}
    </SectionContent>
  </SectionWrapper>
);

Section.displayName = "DS.Section";

export default Section;
